/**
 * AccountShell.tsx — MER Algo Footprints
 *
 * Phase-2 P2-D13 IMPL-4 (D-P2AT-25). The account and recovery shell: the frame
 * for surfaces that must stay reachable whatever a user's commercial access —
 * account security and administration.
 *
 * ── Why it is not AppShell ────────────────────────────────────────────────────
 *
 * AppShell hydrates user preferences and the watchlist, dispatches shadow
 * observations and starts the market-data runtime on EVERY route it wraps. A
 * user without commercial access must still be able to change their password,
 * unlink Google or administer entitlements, and must not trigger commercial
 * traffic while doing so. So this shell deliberately imports nothing but
 * React, the router and the auth context: no store, no hydration hook, no
 * runtime, no market module.
 *
 * It sits under ProtectedRoute and OUTSIDE the commercial boundary, which is
 * where it will stay when enforcement is activated.
 */

import React, { useCallback } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

const LINK: React.CSSProperties = {
  color: '#8BACC8', fontSize: 11, letterSpacing: 1, textDecoration: 'none',
  padding: '6px 10px', borderRadius: 3, border: '1px solid transparent',
};
const ACTIVE: React.CSSProperties = { ...LINK, color: '#C9A84C', borderColor: '#1A3050' };

export function AccountShell() {
  const { logout, entitlement } = useAuth();
  const navigate = useNavigate();

  const signOut = useCallback(async () => {
    await logout();
    navigate('/', { replace: true });
  }, [logout, navigate]);

  return (
    <div className="mer-full-page" style={{
      display: 'flex', flexDirection: 'column', background: '#080F1C',
      fontFamily: "'Courier New', Courier, monospace",
    }}>
      <header style={{
        display: 'flex', alignItems: 'center', gap: 16, padding: '10px 20px',
        borderBottom: '1px solid #1A3050', flex: '0 0 auto',
      }}>
        <Link to="/app" style={{ ...LINK, color: '#C9A84C', fontWeight: 700, letterSpacing: 3 }}>
          ← MER ALGO FOOTPRINTS
        </Link>
        <nav style={{ display: 'flex', gap: 6, marginLeft: 'auto', alignItems: 'center' }}>
          <NavLink to="/app/security" style={({ isActive }) => (isActive ? ACTIVE : LINK)}>
            Account &amp; security
          </NavLink>
          {entitlement.isAdmin && (
            <NavLink to="/app/admin/users" style={({ isActive }) => (isActive ? ACTIVE : LINK)}>
              Users
            </NavLink>
          )}
          <button type="button" onClick={signOut} style={{ ...LINK, background: 'transparent', cursor: 'pointer', fontFamily: 'inherit' }}>
            Sign out
          </button>
        </nav>
      </header>
      <main style={{ flex: '1 1 auto', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </main>
    </div>
  );
}
